import { SuburbanBathroomContainer } from '../../containers/advancedFilters/SuburbanBathroomContainer';
import { IFilter } from '../../types/advancedFilters';

export const suburbanBathroom: IFilter = {
  component: SuburbanBathroomContainer,
};
